import { render } from "./MyPublicHotelPage.vue?vue&type=template&id=99dc5442"
import script from "./MyPublicHotelPage.vue?vue&type=script&lang=js"
export * from "./MyPublicHotelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__